import { createSlice } from "@reduxjs/toolkit";
import { generateUrlUpload, upload, uploadTechnicianCertificate } from "./uploadDocsActions";

const initialState = {
  uploadLoading: false,
  generateUrlUploadLoading: false,
};

const uploadDocsSlice = createSlice({
  name: "uploadDocs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(upload.pending, (state) => {
        state.uploadLoading = true;
      })
      .addCase(upload.fulfilled, (state) => {
        state.uploadLoading = false;
      })
      .addCase(upload.rejected, (state) => {
        state.uploadLoading = false;
      })
      .addCase(generateUrlUpload.pending, (state) => {
        state.generateUrlUploadLoading = true;
      })
      .addCase(generateUrlUpload.fulfilled, (state) => {
        state.generateUrlUploadLoading = false;
      })
      .addCase(generateUrlUpload.rejected, (state) => {
        state.generateUrlUploadLoading = false;
      });
    builder.addCase(uploadTechnicianCertificate.pending, (state) => {
      state.uploadLoading = true;
    })
      .addCase(uploadTechnicianCertificate.fulfilled, (state) => {
        state.uploadLoading = false;
      })
      .addCase(uploadTechnicianCertificate.rejected, (state) => {
        state.uploadLoading = false;
      });
  },
});

export default uploadDocsSlice.reducer;
